import Selector from '../selector';
import { CellRange } from '../../core/cell_range';

export default class FormAreaManage {
  constructor(overlayerCEl,data,table) {
    //image标签父级标签
    this.overlayerCEl = overlayerCEl;
    // selector
    this.selector = new Selector(data);
    this.data = data;
    this.table = table;

    //存储表单配置区域显示信息
    this.formAreasMsg = this.data.formAreas || {
      //表单配置区域
      formConfigArea:[],
      /**
       * [{
       *    tableId:'',//表单id
       *    name:'',//表单名称
       *    titleArea:{},//标题区域
       *    fieldTitleRow:{},//字段标题行
       *    firstSelectRow:{},//首选导入数据行
       *    range:{
              sri:selectRange.sri,
              sci:selectRange.sci,
              eri:selectRange.eri,
              eci:selectRange.eci,
              w:selectRect.width,
              h:selectRect.height},
            key:selectRange.toKeyString(),
            rangeKey:selectRange.toString(),
            type:'formConfigArea',
       * }]
       */
    };
  }

  /**
   * 检测选择区域是否存在单元格设置表单配置区域
   * @param {*} selectRange 选择范围
   */
  checkIsSetFormArea(selectRange,form,isNeedReturnArea=false){
    if (selectRange) {
      for (const key in this.formAreasMsg) {
        if (Object.hasOwnProperty.call(this.formAreasMsg, key)) {
          const formAreaMsgArr = this.formAreasMsg[key] || [];
          for (let index = 0; index < formAreaMsgArr.length; index++) {
            const element = formAreaMsgArr[index];
            let range = new CellRange(element.range.sri, element.range.sci, element.range.eri, element.range.eci, element.range.w, element.range.h);
            if (range && range.intersects(selectRange)) {
              if (!form) {
                if (isNeedReturnArea) {
                  return element;
                }else{
                  return true;
                }
              }else{
                if (form && element.tableId == form.table_id) {
                  if (isNeedReturnArea) {
                    return element;
                  }else{
                    return true;
                  }
                }
              }
            }
          }
        }
      }
    }
    if (isNeedReturnArea) {
      return null;
    }else{
      return false;
    }
  }

  //处理块显示位置Offset
  formAreaSetOffset(moveType,distance,data) {
    console.log("ImageManage formAreaSetOffset......",moveType,distance );
    this.formAreasArr.forEach(imgObj => {
      imgObj.setImageOffset(data,distance,moveType);
    });
  }

  //处理块设定
  formAreaSet(selectRange,type,data,form,callbackFunc,isUpdate=false) {
    if (selectRange) {
      let formAreaMsgArr = this.formAreasMsg[type] || [];
      let selectRect = data.getRect(selectRange);
      let formAreaIndex = formAreaMsgArr.findIndex(item=>{
        return item.tableId == form.table_id
      })
      if (formAreaIndex>-1) {
        let formAreaMsg = formAreaMsgArr[formAreaIndex];
        if (formAreaMsg?.titleArea?.range ||
          formAreaMsg?.fieldTitleRow?.range ||
          formAreaMsg?.firstSelectRow?.range) {
          callbackFunc && callbackFunc({message:'本表区域已经设置，无法再次设置',success:false});
          return
        }
      }
      let msg = {
        tableId:form && form.table_id,//表单id
        name:form && form.tableName,//表单名称
        titleArea:{},//标题区域
        fieldTitleRow:{},//字段标题行
        firstSelectRow:{},//首选导入数据行
        range:{
          sri:selectRange.sri,
          sci:selectRange.sci,
          eri:selectRange.eri,
          eci:selectRange.eci,
          w:selectRect.width,
          h:selectRect.height},
        key:selectRange.toKeyString(),
        rangeKey:selectRange.toString(),
        type
      }

      if (formAreaIndex>-1) {
        formAreaMsgArr.splice(formAreaIndex,1,msg);
      }else{
        formAreaMsgArr.push(msg);
      }
      
      //设定canvas中区域块的边线
      callbackFunc && callbackFunc({message:'',success:true,data:msg});
    
      this.formAreasMsg[type] = formAreaMsgArr;
    }

    data.setFormAreas(this.formAreasMsg);
  }

  //处理块取消，只要选择区域单元格存在对应type的块设置，则取消
  formAreaCancel(selectRange,type,data,form,callbackFunc) {
    if (selectRange) {
      console.log("formAreaCancel selectRange......",selectRange);
      console.log("formAreaCancel type......",type);
      console.log("formAreaCancel data......",data);
      let formAreaMsgArr = this.formAreasMsg[type];
      if (formAreaMsgArr && formAreaMsgArr.length>0) {
        for (let index = 0; index < formAreaMsgArr.length; index++) {
          const element = formAreaMsgArr[index];
          console.log("formAreaCancel11......",element.range);
          let range = new CellRange(element.range.sri, element.range.sci, element.range.eri, element.range.eci, element.range.w, element.range.h);
          if ((range && range.intersects(selectRange))) {
            //删除canvas中区域的划线
            console.log("formAreaCancel22......",selectRange);
            //删除了缓存块数据
            formAreaMsgArr.splice(index,1);
            callbackFunc && callbackFunc({success:true,message:''})
            break;
          }
        }
      }
    }else{
      if (form) {
        let formAreaMsgArr = this.formAreasMsg[type];
        if (formAreaMsgArr && formAreaMsgArr.length>0) {
          for (let index = 0; index < formAreaMsgArr.length; index++) {
            const element = formAreaMsgArr[index];
            console.log("formAreaCancel11......",element.range);
            if (element.tableId == form.table_id) {
              //删除了缓存块数据
              formAreaMsgArr.splice(index,1);
              callbackFunc && callbackFunc({success:true,message:''})
              break;
            }
          }
        }
      }
    }
    console.log("formAreaCancel33......",JSON.parse(JSON.stringify(this.formAreasMsg)));
    data.setFormAreas(this.formAreasMsg);
  }

  setFormAreaMsg(formAreas){
    this.formAreasMsg = formAreas;
  }

  //清空formAreas数据
  clearformAreasArr(){
    
  }

  /**
   * 检测配置的区域是否在某表的范围内
   * @param {*} selectRange 框定范围
   */
   checkIsLocationFormArea(selectRange,form){
    if (selectRange) {
      for (const key in this.formAreasMsg) {
        if (Object.hasOwnProperty.call(this.formAreasMsg, key)) {
          const formAreaMsgArr = this.formAreasMsg[key] || [];
          for (let index = 0; index < formAreaMsgArr.length; index++) {
            const element = formAreaMsgArr[index];
            let range = new CellRange(element.range.sri, element.range.sci, element.range.eri, element.range.eci, element.range.w, element.range.h);
            if (range && range.contains(selectRange)) {
              if (!form) {
                return true;
              }else{
                if (form && element.tableId == form.table_id) {
                  return true;
                }
              }
            }
          }
        }
      }
    }
    return false;
  }

  //标题区域设置
  formAreaTitleSet(selectRange,type,data,form,callbackFunc) {
    if (selectRange) {
      console.log("this.formAreasMsg......",this.formAreasMsg);
      console.log("type......",type);
      console.log("form......",form);
      let formAreaMsgArr = this.formAreasMsg[type] || [];
      console.log("formAreaMsgArr......",formAreaMsgArr);
      let selectRect = data.getRect(selectRange);
      if (formAreaMsgArr.length==0 || !this.checkIsSetFormArea(selectRange,form)) {
        callbackFunc && callbackFunc({message:'圈定区域未设置子表范围，请先设置',success:false})
      }else{
        let formAreaMsg = formAreaMsgArr.find(item=>{
          return item.tableId == form.table_id
        })
        let index = formAreaMsgArr.findIndex(item=>{
          return item.tableId == form.table_id
        })
        console.log("index......",index);
        console.log("selectRange.toKeyString()......",selectRange.toKeyString());
        if (formAreaMsg) {
          if (!this.checkIsLocationFormArea(selectRange,form)) {
            callbackFunc && callbackFunc({message:'圈定区域超出子表范围内，请重新设置',success:false})
            return;
          }

          formAreaMsg.titleArea = {
            range:{
              sri:selectRange.sri,
              sci:selectRange.sci,
              eri:selectRange.eri,
              eci:selectRange.eci,
              w:selectRect.width,
              h:selectRect.height},
            key:selectRange.toKeyString(),
            rangeKey:selectRange.toString(),
          };//标题区域

          let alertStr = this.judgeFirstRowBeforeIsHaveTitle(formAreaMsg.firstSelectRow.range,formAreaMsg);
          if (alertStr!='') {
            callbackFunc && callbackFunc({message:alertStr,success:false})
            delete formAreaMsg.titleArea;
            return;
          }

          //替换数据
          formAreaMsgArr.splice(index,1,formAreaMsg);
          callbackFunc && callbackFunc({success:true,message:'',data:formAreaMsg})
        }else{
          callbackFunc && callbackFunc({message:'圈定区域未设置子表范围，请先设置',success:false})
        }
      }
      console.log("formAreaMsgArr......",formAreaMsgArr);
      this.formAreasMsg[type] = formAreaMsgArr;
    }

    data.setFormAreas(this.formAreasMsg);
  }

  //标题区域取消
  formAreaTitleCancel(selectRange,type,data,form,callbackFunc) {
    // if (selectRange) 
    {
      let formAreaMsgArr = this.formAreasMsg[type] || [];
      if (formAreaMsgArr.length==0) {
        // callbackFunc && callbackFunc({message:'未设置子表标题区域，无法取消',success:false})
      }else{
        let formAreaMsg = formAreaMsgArr.find(item=>{
          return item.tableId == form.table_id
        })
        let index = formAreaMsgArr.findIndex(item=>{
          return item.tableId == form.table_id
        })
        if (formAreaMsg) {
          formAreaMsg.titleArea = {},//标题区域
          //替换数据
          formAreaMsgArr.splice(index,1,formAreaMsg);
          callbackFunc && callbackFunc({message:'',success:true})
        }else{
          // callbackFunc && callbackFunc({message:'未设置子表标题区域，无法取消',success:false})
        }
      }
      this.formAreasMsg[type] = formAreaMsgArr;
    }

    data.setFormAreas(this.formAreasMsg);
  }

  //标题行区域设置
  formAreaTitleRowSet(selectRange,type,data,form,callbackFunc) {
    if (selectRange) {
      console.log("this.formAreasMsg......",this.formAreasMsg);
      console.log("type......",type);
      console.log("form......",form);
      let formAreaMsgArr = this.formAreasMsg[type] || [];
      console.log("formAreaMsgArr......",formAreaMsgArr);
      let selectRect = data.getRect(selectRange);
      if (formAreaMsgArr.length==0 || !this.checkIsSetFormArea(selectRange,form)) {
        callbackFunc && callbackFunc({message:'圈定区域未设置子表范围，请先设置',success:false})
      }else{
        let formAreaMsg = formAreaMsgArr.find(item=>{
          return item.tableId == form.table_id
        })
        let index = formAreaMsgArr.findIndex(item=>{
          return item.tableId == form.table_id
        })
        console.log("index......",index);
        if (formAreaMsg) {
          if (!this.checkIsLocationFormArea(selectRange,form)) {
            callbackFunc && callbackFunc({message:'圈定区域超出子表范围内，请重新设置',success:false})
            return;
          }
          
          //标题行只能设定一行，不能选择多行，看这个是否需要处理判断
          formAreaMsg.fieldTitleRow = {
            range:{
              sri:selectRange.sri,
              sci:selectRange.sci,
              eri:selectRange.eri,
              eci:selectRange.eci,
              w:selectRect.width,
              h:selectRect.height},
            key:selectRange.toKeyString(),
            rangeKey:selectRange.toString(),
          };//标题区域
          
          let alertStr = this.judgeFirstRowBeforeIsHaveTitle(formAreaMsg.firstSelectRow.range,formAreaMsg);
          if (alertStr!='') {
            callbackFunc && callbackFunc({message:alertStr,success:false})
            delete formAreaMsg.fieldTitleRow;
            return;
          }

          //替换数据
          formAreaMsgArr.splice(index,1,formAreaMsg);
          callbackFunc && callbackFunc({success:true,message:'',data:formAreaMsg})
        }else{
          callbackFunc && callbackFunc({message:'圈定区域未设置子表范围，请先设置',success:false})
        }
      }
      console.log("formAreaMsgArr......",formAreaMsgArr);
      this.formAreasMsg[type] = formAreaMsgArr;
    }

    data.setFormAreas(this.formAreasMsg);
  }

  //标题行区域取消
  formAreaTitleRowCancel(selectRange,type,data,form,callbackFunc) {
    // if (selectRange) 
    {
      let formAreaMsgArr = this.formAreasMsg[type] || [];
      if (formAreaMsgArr.length==0) {
        // callbackFunc && callbackFunc('未设置子表标题区域，无法取消')
      }else{
        let formAreaMsg = formAreaMsgArr.find(item=>{
          return item.tableId == form.table_id
        })
        let index = formAreaMsgArr.findIndex(item=>{
          return item.tableId == form.table_id
        })
        if (formAreaMsg) {
          formAreaMsg.fieldTitleRow = {},//标题区域
          //替换数据
          formAreaMsgArr.splice(index,1,formAreaMsg);
          callbackFunc && callbackFunc({success:true,message:''})
        }else{
          // callbackFunc && callbackFunc('未设置子表标题区域，无法取消')
        }
      }
      this.formAreasMsg[type] = formAreaMsgArr;
    }

    data.setFormAreas(this.formAreasMsg);
  }

  //首选行区域设置
  formAreaFirstRowSet(selectRange,type,data,form,callbackFunc) {
    if (selectRange) {
      console.log("this.formAreasMsg......",this.formAreasMsg);
      console.log("type......",type);
      console.log("form......",form);
      let formAreaMsgArr = this.formAreasMsg[type] || [];
      console.log("formAreaMsgArr......",formAreaMsgArr);
      let selectRect = data.getRect(selectRange);
      if (formAreaMsgArr.length==0 || !this.checkIsSetFormArea(selectRange,form)) {
        callbackFunc && callbackFunc({message:'圈定区域未设置子表范围，请先设置',success:false})
      }else{
        let formAreaMsg = formAreaMsgArr.find(item=>{
          return item.tableId == form.table_id
        })
        let index = formAreaMsgArr.findIndex(item=>{
          return item.tableId == form.table_id
        })
        console.log("index......",index);
        if (formAreaMsg) {
          //首选行只能设定一行，不能选择多行
          if (!((selectRange.sri == selectRange.eri) || (selectRange.sci == selectRange.eci))) {
            callbackFunc && callbackFunc({message:'首选行只能设定一行或者一列,请重新设置',success:false})
            return;
          } 
          if (!this.checkIsLocationFormArea(selectRange,form)) {
            callbackFunc && callbackFunc({message:'圈定区域超出子表范围内，请重新设置',success:false})
            return;
          }
          let alertStr = this.judgeFirstRowBeforeIsHaveTitle(selectRange,formAreaMsg);
          if (alertStr!='') {
            callbackFunc && callbackFunc({message:alertStr,success:false})
            return;
          }
          formAreaMsg.firstSelectRow = {
            range:{
              sri:selectRange.sri,
              sci:selectRange.sci,
              eri:selectRange.eri,
              eci:selectRange.eci,
              w:selectRect.width,
              h:selectRect.height},
            key:selectRange.toKeyString(),
            rangeKey:selectRange.toString(),
          },//标题区域
          //替换数据
          formAreaMsgArr.splice(index,1,formAreaMsg);
          callbackFunc && callbackFunc({success:true,message:'',data:formAreaMsg})
        }else{
          callbackFunc && callbackFunc({message:'圈定区域未设置子表范围，请先设置',success:false})
        }
      }
      console.log("formAreaMsgArr......",formAreaMsgArr);
      this.formAreasMsg[type] = formAreaMsgArr;
    }

    data.setFormAreas(this.formAreasMsg);
  }

  //首选行区域取消
  formAreaFirstRowCancel(selectRange,type,data,form,callbackFunc) {
    // if (selectRange) 
    {
      let formAreaMsgArr = this.formAreasMsg[type] || [];
      if (formAreaMsgArr.length==0) {
        // callbackFunc && callbackFunc('未设置子表标题区域，无法取消')
      }else{
        let formAreaMsg = formAreaMsgArr.find(item=>{
          return item.tableId == form.table_id
        })
        let index = formAreaMsgArr.findIndex(item=>{
          return item.tableId == form.table_id
        })
        if (formAreaMsg) {
          formAreaMsg.firstSelectRow = {},//标题区域
          //替换数据
          formAreaMsgArr.splice(index,1,formAreaMsg);
          callbackFunc && callbackFunc({success:true,message:''})
        }else{
          // callbackFunc && callbackFunc('未设置子表标题区域，无法取消')
        }
      }
      this.formAreasMsg[type] = formAreaMsgArr;
    }

    data.setFormAreas(this.formAreasMsg);
  }
  //判断首选行区域前面是否存在标题或者标题行任意一个区域，存在则提示
  judgeFirstRowBeforeIsHaveTitle(selectRange,formAreaMsg){
    if (selectRange) {
      if (formAreaMsg) {
        let titleAreaRange = formAreaMsg.titleArea && formAreaMsg.titleArea.range;//标题区域
        let fieldTitleRowRange = formAreaMsg.fieldTitleRow && formAreaMsg.fieldTitleRow.range;//标题行区域
        let isBeforeHave = false

        if (selectRange.sri == selectRange.eri) { //行循环
          if (titleAreaRange && titleAreaRange.eri < selectRange.sri) {
            isBeforeHave = true
          }
          if (fieldTitleRowRange && fieldTitleRowRange.eri < selectRange.sri) {
            isBeforeHave = true
          }
        }else if (selectRange.sci == selectRange.eci){ //列循环
          if (titleAreaRange && titleAreaRange.eci < selectRange.sci) {
            isBeforeHave = true
          }
          if (fieldTitleRowRange && fieldTitleRowRange.eci < selectRange.sci) {
            isBeforeHave = true
          }
        }

        if ((!titleAreaRange && !fieldTitleRowRange) || (fieldTitleRowRange && !titleAreaRange) || (!fieldTitleRowRange && titleAreaRange)) {
          isBeforeHave = true
        }

        if (selectRange.sri == selectRange.eri) { //行循环
          if (!isBeforeHave) {
            return '首选行区域上方区域需要指定标题或者标题行区域任意一个';
          }
        }else if (selectRange.sci == selectRange.eci){ //列循环
          if (!isBeforeHave) {
            return '首选行区域左方区域需要指定标题或者标题行区域任意一个';
          }
        }
      }
    }
    return ''
  }
}
